(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["noel-coffrets"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noel-coffrets')) {
    class NoelCoffrets extends HTMLElement {
      connectedCallback() {
        this.besoinPills = [...this.querySelectorAll('[data-nc-besoin]')];
        this.budgetPills = [...this.querySelectorAll('[data-nc-budget]')];
        this.items = [...this.querySelectorAll('[data-nc-item]')];
        this.besoinPills.forEach((p) => {
          if (p.dataset.ncBesoin && !this.items.some((i) => i.dataset.besoin.split(' ').includes(p.dataset.ncBesoin))) p.hidden = true;
        });
        this.count = this.querySelector('[data-nc-count]');
        this.empty = this.querySelector('[data-nc-empty]');

        const params = new URLSearchParams(location.search);
        this.select(this.besoinPills, 'ncBesoin', params.get('besoin') || '');
        this.select(this.budgetPills, 'ncBudget', params.get('budget') || '');
        this.besoinPills.forEach((p) => p.addEventListener('click', () => { this.select(this.besoinPills, 'ncBesoin', p.dataset.ncBesoin); this.apply(true); }));
        this.budgetPills.forEach((p) => p.addEventListener('click', () => { this.select(this.budgetPills, 'ncBudget', p.dataset.ncBudget); this.apply(true); }));
        this.apply(false);

        this.addEventListener('click', (e) => {
          const trigger = e.target.closest('[data-nc-ask]');
          if (!trigger) return;
          e.preventDefault();
          this.ask(trigger.dataset.ncAsk);
        });
        const form = this.querySelector('[data-nc-ask-form]');
        if (form) {
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.ask(form.q.value.trim());
            form.reset();
          });
        }
      }

      select(pills, key, value) {
        const match = pills.find((p) => p.dataset[key] === value) || pills[0];
        pills.forEach((p) => p.setAttribute('aria-pressed', p === match ? 'true' : 'false'));
      }

      active(pills) {
        return pills.find((p) => p.getAttribute('aria-pressed') === 'true');
      }

      apply(updateUrl) {
        const besoin = this.active(this.besoinPills);
        const budget = this.active(this.budgetPills);
        const besoinKey = besoin ? besoin.dataset.ncBesoin : '';
        const min = budget && budget.dataset.min ? Number(budget.dataset.min) : 0;
        const max = budget && budget.dataset.max ? Number(budget.dataset.max) : Infinity;
        let shown = 0;
        this.items.forEach((item) => {
          const price = Number(item.dataset.price);
          const visible = (!besoinKey || item.dataset.besoin.split(' ').includes(besoinKey)) && price >= min && price < max;
          item.hidden = !visible;
          if (visible) shown += 1;
        });
        if (this.count) this.count.textContent = (shown === 1 ? this.count.dataset.one : this.count.dataset.many).replace('{nb}', shown);
        if (this.empty) this.empty.hidden = shown > 0;
        if (updateUrl) {
          const url = new URL(location.href);
          const budgetKey = budget ? budget.dataset.ncBudget : '';
          if (besoinKey) url.searchParams.set('besoin', besoinKey); else url.searchParams.delete('besoin');
          if (budgetKey) url.searchParams.set('budget', budgetKey); else url.searchParams.delete('budget');
          history.replaceState(null, '', url);
        }
      }

      // Ouvre l'assistant Dialog. Dialog n'expose pas d'API pour poser une question : on remplit son champ.
      // Le tiroir vide son champ à chaque message d'accueil, donc on le remplit à nouveau pendant 15 s,
      // sauf dès que la cliente tape, envoie ou clique dans la conversation.
      ask(question) {
        window.dispatchEvent(new CustomEvent('enableDialogAssistantEvent', {
          detail: { type: 'START_DIAGNOSTIC', payload: { buttonType: 'SIMPLE_BUTTON_DIAGNOSTIC', personalShopperId: this.dataset.shopper } }
        }));
        if (!question) return;
        const started = Date.now();
        let stopped = false;
        let bound = null;
        const stop = () => { stopped = true; };
        const timer = setInterval(() => {
          if (stopped || Date.now() - started > 15000) { clearInterval(timer); return; }
          const input = document.getElementById('dialog-ai-input');
          if (!input) return;
          if (bound !== input) {
            bound = input;
            input.addEventListener('keydown', stop, { once: true });
            if (input.form) {
              input.form.addEventListener('submit', stop, { once: true });
              input.form.addEventListener('pointerdown', (e) => { if (e.target.closest('button')) stop(); });
            }
          }
          const send = input.form && input.form.querySelector('button');
          if (input.value === question && (!send || !send.disabled)) return;
          const setter = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(input), 'value').set;
          setter.call(input, question);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        }, 400);
      }
    }
    customElements.define('noel-coffrets', NoelCoffrets);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
